import { Box } from '../global/box.js';

export class Addon extends Box  {
    constructor(element) {
        super(element);
        this._trackType = 'addon';
        this.init();
    }
    
    get title() {
        return this._json.title;
    }
    
    get price() {
        return this._json.price;
    }
    
    get surcharge() {
        return this._json.surcharge || 0;
    }
    
    init() {
        super.init();
        this._element.addEventListener('click', event => {
            event.preventDefault();
            (this._checkbox.checked) ? this.unselect() : this.select();
        });
    }
    
    select() {
        this.fireEvent('selectAddon', {addon: this});
        super.select();
    }
    
    unselect() {
        this.fireEvent('unselectAddon', {addon: this});
        super.unselect();
    }
}
